module.exports = __webpack_public_path__ + "img/about.dad0b975.jpg";